import _ from "lodash-es";
import moment from "moment";

export const dateFormat = 'YYYY-MM-DD';
//HH is 24-hour. Lowercase hh is 12-hour, and with no am/pm token it rendered 13:45 as
//01:45, making afternoon timestamps indistinguishable from morning ones
export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const primeVueDateFormat = 'yy-mm-dd';

export function parseDateTime(date) {
    return date ? moment(date).format(dateTimeFormat) : null
}

export function parseDate(date) {
    return date ? moment(date).format(dateFormat) : null
}

export function today() {
    return moment().format(dateFormat)
}

const normalizeProgressValue = value => {
    const numericValue = Number(value)
    if (!Number.isFinite(numericValue)) {
        return 0
    }
    return _.clamp(numericValue, 0, 1)
}

export const progressColor = value => {
    const normalizedValue = normalizeProgressValue(value)
    let color
    const percentage = normalizedValue * 100

    if (percentage < 35) {
        color = '#cc0000'; // red
    } else if (percentage < 75) {
        color = '#ffa500'; // orange
    } else {
        color = '#00aa00'; // green
    }

    return color;
}

export const progressTooltip = (name, value) => {
    const contents = {
        digitalization: 'indicates how many of your activities are measurable, i.e. can be found in the data.',
        adherence_ratio: 'indicates which ratio of process instances and their activities found in the data conform with the defined business rule(s).',
        coverage: 'indicates how much of your process is under control, i.e. defined business rules.'
    }
    const normalizedValue = normalizeProgressValue(value)
    const label = `${_.startCase(name)}: ${parseInt(normalizedValue * 100)}%`
    //a metric with no entry in `contents` must not render "- undefined" at the user
    return contents[name] ? `${label} - ${contents[name]}` : label
}

export const getDocsLink = (path = '') => {
    const base = import.meta.env.VITE_SERVICE_IMAGE_TAG
        ? '/docs/'
        : 'http://localhost:8080/docs/';
    if (!path) {
        return base;
    }
    const normalized = path.startsWith('/') ? path.slice(1) : path;
    return `${base}${normalized}`;
}

export const IS_TRAINING_INSTANCE = import.meta.env?.VITE_APP_TRAINING_INSTANCE === 'true';

/**
 * Whether a form field value counts as "not filled in" for a required field.
 *
 * Only null, undefined and the empty string are empty. A plain falsiness check would
 * reject 0 and false, which are legitimate values for numeric and boolean fields.
 * Note this is deliberately NOT lodash's _.isEmpty, which reports 0 and false as empty.
 *
 * Shared by FormField.vue and CustomForm.vue: they validate the same fields, so the two
 * must agree or a field can render as valid while its form refuses to submit.
 */
export const isEmptyFieldValue = value => value === null || value === undefined || value === '';